import "@arco-design/web-react/es/Select/style";
import _Select from "@arco-design/web-react/es/Select";
import React from 'react';
export function SelectOptions({
  value,
  onChange,
  options,
  placeholder = '全部'
}) {
  return /*#__PURE__*/React.createElement(_Select, {
    value: value,
    onChange: onChange,
    placeholder: placeholder,
    options: options,
    allowClear: true
  });
}